import { useTranslation } from 'react-i18next';
import AccountTerminationModalBase from '@/components/ModalRenderer/components/components/AccountTerminationModalBase';

const ConfirmEndAgreement = () => {
  const { t } = useTranslation('Modal');

  return (
    <AccountTerminationModalBase
      title={t('ConfirmEndAgreement.title')}
      buttonText={t('ConfirmEndAgreement.button')}
    >
      <p>{t('ConfirmEndAgreement.info')}</p>
    </AccountTerminationModalBase>
  );
};

export default ConfirmEndAgreement;
